<script>import { clickOutside } from "../../actions";
import { colors } from "../../theme/colors";
import { attrValue } from "../../utils/html";
export let isOpen = false;
export let close = null;
export let withArrow = false;
export let position = "left";
export let triggerRef = null;
export let classNames = "";
let arrowStyleVar = `--arrow-border-color: ${colors.grey.light}; --arrow-bg-color: ${colors["white"]}`;
</script>

{#if isOpen}
	<div
		class="dropdown"
		style={arrowStyleVar}
		class:with-arrow={withArrow}
		class:is-positioned-left={position === 'left'}
		class:is-positioned-center={position === 'center'}
		class:is-positioned-right={position === 'right'}
		use:clickOutside={{ action: close, disabled: !isOpen, excludedRefs: [triggerRef] }}
	>
		<div
			class={attrValue([
				'inner rounded-md p-3',
				classNames,
				'inner',
				'border border-grey-light bg-white'
			])}
		>
			<slot />
		</div>
	</div>
{/if}

<style>.dropdown{top:100%;--dropdown-padding-top:10px;padding-top:10px;padding-top:var(--dropdown-padding-top);position:absolute;width:-moz-max-content;width:max-content;z-index:1998}.inner{--dropdown-after-content:none}.with-arrow{--dropdown-padding-top:10px}.with-arrow .inner{--dropdown-after-content:""}.dropdown.is-positioned-left{left:0;--arrow-left-position:15%}.dropdown.is-positioned-center{left:50%;--tw-translate-x:-50%;transform:translate(-50%,var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));--arrow-left-position:50%}.dropdown.is-positioned-right{right:0;--arrow-left-position:85%}.inner:after,.inner:before{border-style:solid;content:var(--dropdown-after-content);display:block;height:0;position:absolute;transform:translateX(-50%);width:0}.inner:after{border-color:transparent transparent var(--arrow-bg-color) transparent;border-width:9px;top:calc(-17px + var(--dropdown-padding-top))}.inner:after,.inner:before{left:var(--arrow-left-position)}.inner:before{border-color:transparent transparent var(--arrow-border-color) transparent;border-width:10px;top:calc(-19px + var(--dropdown-padding-top))}</style>
